import { useEffect, useRef } from 'react';
import scrollEventFn from '../scroll_event';

export default function Management() {
  const scroll01 = useRef(null);
  const scroll02 = useRef(null);
  const scrollArr = [scroll01, scroll02];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const cb = () => scrollEventFn(scrollArr);
    cb();
    window.addEventListener('scroll', cb);
    return () => window.removeEventListener('scroll', cb);
  }, []);

  return (
    <div className="contents management">
      <div className="content-title02">윤리경영</div>
      <div className="content-text01 scrollBox" ref={scroll01}>
        ㈜DX손해사정법인은 건전한 보험산업 육성에 기여하며 바람직한 기업의
        역할을 성실하게 수행하고자 사회적 책임과 의무를 위한 윤리경영을 실천하고
        있습니다. 이를 위해 윤리강령을 제정하고, 모든 경영 활동 및 구성원의
        의사결정과 행동 판단의 기준으로 삼고 있습니다.
        <img src="/img/sub_management_01.png" alt="" />
      </div>
      <div className="top-100">
        <div className="content-title02">제보하기</div>
        <div className="cm-column-txt-con scrollBox" ref={scroll02}>
          <div className="column-tit-box">
            <h4>윤리경영센터</h4>
          </div>
          <div className="column-txt-box">
            <dl className="report-info-box">
              <dt className="report-sub-tit">신고/제보</dt>
              <dd>
                <p className="report-sub-txt">
                  · ㈜DX손해사정법인은 임직원의 비리 및 직위를 이용한 부당한
                  요구 행위 등에 대하여 제보를 접수하고 있으며,
                  <br /> 접수된 내용은 지정된 담당자만 열람할 수 있습니다.
                </p>
                <p className="report-sub-txt">
                  · ㈜DX손해사정법인은 비윤리적 행위에 대해 끊임없이 개선하고
                  건강한 조직문화를 만들기 위해 노력하고 있습니다.
                </p>
              </dd>
            </dl>
            <dl className="report-info-box top-30">
              <dt className="report-sub-tit">제보유형</dt>
              <dd>
                <p className="report-sub-txt">
                  · 임직원 공금횡령/유용/금품 수뢰
                </p>
                <p className="report-sub-txt">· 임직원 부정사안</p>
                <p className="report-sub-txt">· 거래처 부당 지분참여행위</p>
                <p className="report-sub-txt">· 거래처 청탁/부당 요구</p>
                <p className="report-sub-txt">· 상사 직권 남용 (갑질)</p>
                <p className="report-sub-txt">
                  · 업무외적 사업행위/이중 취업행위
                </p>
                <p className="report-sub-txt">· 성희롱/풍기문란 행위</p>
                <p className="report-sub-txt">· 기타 사례 (윤리강령 위반)</p>
              </dd>
            </dl>
            <dl className="report-info-box top-30">
              <dt className="report-sub-tit">신고처</dt>
              <dd>
                <p className="report-sub-txt">
                  <strong>우편</strong>
                </p>
                <p className="report-sub-txt">
                  서울특별시 마포구 양화로 92, 6층 (서교동, 유남빌딩)
                </p>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
}
